import React, { useState } from "react";
import useCourseSubjects from "../../../utils/use-CourseSubjects";
import { COURSE_DETAILS_CLASSROOM_HEADING } from "../../../constants/text_constants";
import InValidLottie from "../../Lottie-Components/InValidLottie";
import CourseSubjectsDropdown from "./CourseSubjectsDropdown";
import ClassroomTabLectures from "../../CourseDetail/ClassroomTabLectures";
import ClassroomTabNotes from "../../CourseDetail/ClassroomTabNotes";


const CourseClassroomTab = ({ courseId, isPurchased, data }) => {
  const courseSubjects = useCourseSubjects(courseId);
  const [subjectId, setSubjectId] = useState(null);
  const [showLecture, setShowLecture] = useState(true);
  const [searchLectureText, setSearchLectureText] = useState("");
  const userAuthenticated = sessionStorage.getItem("authenticated") === "1";

  if (!userAuthenticated) {
    return (
      <div className="mx-[1rem] mb-[58px] md:mb-0">
        <div className="lg:text-2xl text-lg font-semibold my-6">
          {COURSE_DETAILS_CLASSROOM_HEADING}
        </div>
        <div>
          <InValidLottie text={"You Need to Login to view Classroom"} />
        </div>
      </div>
    );
  }

  return (
    <div className="mx-[1.3rem] mb-[250px] md:mb-0">
      <div className="lg:text-2xl text-lg font-semibold my-6">
        {COURSE_DETAILS_CLASSROOM_HEADING}
      </div>

      <div>
        {/* Section 1 - Course DropDown*/}
        <div>
          <CourseSubjectsDropdown
            courseSubjects={courseSubjects}
            setSubjectId={setSubjectId}
            defaultSubjectId={courseSubjects?.subjects[0]?.id}
            subjectId={subjectId}
          />
        </div>
        {/* Section 2 - Default view when no Subject Id is selected*/}
        {!subjectId && (
          <div className="my-6 text-center">
            Select Subject to View{" "}
            <span className="font-semibold text-[#01B2C2] underline underline-offset-4">
              Lectures
            </span>{" "}
            and{" "}
            <span className="font-semibold text-[#01B2C2] underline underline-offset-4">
              Notes
            </span>
          </div>
        )}
        {/* Section 3 - SubjectId is selected and Tabs View */}
        {subjectId && (
  <div
    className="
      bg-[#F8FCFD] border border-[#DFE3EC] px-4 py-3 rounded-t-xl font-semibold mt-[1rem]
      flex flex-col gap-3
      md:flex-row md:justify-between md:items-center
    "
  >
    <div className="flex items-center gap-2">
      <div
        onClick={() => setShowLecture(true)}
        className={showLecture ? "text-[#03B3C3]" : ""}
      >
        Lectures
      </div>

      <div className="text-[#DFE3EC] text-2xl md:block"> | </div>

      <div
        onClick={() => setShowLecture(false)}
        className={!showLecture ? "text-[#03B3C3]" : ""}
      >
        Notes
      </div>
    </div>

    <div>
      <input
        type="text"
        placeholder="Search Lectures"
        className="py-2 pr-2 pl-3 rounded-lg bg-white border border-slate-400 w-full md:w-[18rem] focus:outline-none text-sm font-semibold"
        onChange={(e) => setSearchLectureText(e.target.value)}
      />
    </div>
  </div>
)}

        {/* Section 4 - SubjectId is Selected and Lectures View */}
        {subjectId && showLecture && (
          <ClassroomTabLectures
            subjectId={subjectId?.id}
            defaultSubjectId={courseSubjects?.subjects[0]?.id}
            isPurchased={isPurchased}
            searchText={searchLectureText}
          />
        )}
        {subjectId && !showLecture && (
          <ClassroomTabNotes
            subjectId={subjectId?.id}
            defaultSubjectId={courseSubjects?.subjects[0]?.id}
            isPurchased={isPurchased}
            data={data}
          />
        )}
      </div>
    </div>
  );
};

export default CourseClassroomTab;
